import React from 'react';

interface IUrvalContext {
  standardGrundUrval: boolean;
}

export const UrvalContext = React.createContext<IUrvalContext>({
  standardGrundUrval: false,
});

export const UrvalContextProvider = UrvalContext.Provider;
export const UrvalContextConsumer = UrvalContext.Consumer;
